module.exports = __webpack_public_path__ + "img/kopiarka-hd.38233596.gif";